import PropTypes from 'prop-types';
import { useEffect, useCallback, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hook';
//
import { useAuthContext } from '../hooks';
import { isStudentUser, studentMayOpen, STUDENT_HOME } from '../student-microsoft-login';

// ----------------------------------------------------------------------

const loginPaths = {
  jwt: paths.auth.jwt.login,
  auth0: paths.auth.auth0.login,
  amplify: paths.auth.amplify.login,
  firebase: paths.auth.firebase.login,
};

// ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const router = useRouter();

  const { authenticated, method, user } = useAuthContext();

  const { pathname } = useLocation();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (user && user.typ === 'device') {
      return router.replace('/device');
    }

    if (!authenticated) {
      // const searchParams = new URLSearchParams({ returnTo: window.location.href }).toString();

      const loginPath = loginPaths[method];

      const href = `${loginPath}`;
      // const href = `${loginPath}?${searchParams}`;

      router.replace(paths.landing);
    } else {
      setChecked(true);
    }
  }, [authenticated, method, router, user]);

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  if (!checked) {
    return null;
  }

  // A student session (#602) sees only the pages built for students.
  if (isStudentUser(user) && !studentMayOpen(pathname)) {
    return <Navigate to={STUDENT_HOME} replace />;
  }

  return <>{children}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};
